// @flow
import React, { useEffect, useState, useRef } from 'react';
import { Badge, Button, Card, Col, Form, Row } from 'react-bootstrap';
import HyperDatepicker from '../../components/Datepicker';
import { FormInput } from '../../components';
import { useSelector } from 'react-redux';
import { Loading } from 'react-loading-ui';
import { getAllStationAPI, getReportAPI, getUserStationAPI } from '../../API/RDPMS_API';
import { ToastContainer, toast } from 'react-toastify';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Table from '../../components/Table';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import reportImg from '../../assets/images/report.png';
import {
    batteriesColumns,
    dcCircuitColumns,
    hassdacColumns,
    IPSColumns,
    pointMachineColumns,
    SignalColumns,
} from '../../utils/ColumnUtils';
import { renderBadge, renderBadgeIPS, renderStatus } from '../../utils/statusUtils';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../src/assets/scss/custom/components/reportalert.scss';
import 'material-design-icons/iconfont/material-icons.css';
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../dashboard/Dashboard/Dashboard.css';
import { Modal } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const ReportsAlert = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedStation, setSelectedStation] = useState();
    const [selectedCategory, setSelectedCategory] = useState();

    const [station, setStation] = useState([]);

    const [dcCircuitData, setDcCircuitData] = useState([]);
    const [pointMachineData, setPointMachineData] = useState([]);
    const [signalData, setSignalData] = useState([]);
    const [batteriesData, setBatteriesData] = useState([]);
    const [ipsData, setIPSData] = useState([]);
    const [hassdacData, setHassdacData] = useState([]);
    const [showExportModal, setShowExportModal] = useState(false);
    const [data, setData] = useState([]);
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    useEffect(() => {
        const fetchStation = async () => {
            await getStation(auth.user._id);
        };

        fetchStation();
    }, []);

    const getStation = async (id) => {
        try {
            if (id) {
                Loading(true); // Show loading spinner
                const response = await getUserStationAPI(id);
                if (response && response.length > 0) {
                    setStation(response);
                }
            }
        } catch (error) {
            console.error('Error fetching station data:', error);
        } finally {
            Loading(false); // Hide loading spinner
        }
    };

    /*
     * handle date change
     */
    // const handleGetReport = async () => {
    //     try {
    //         Loading(true); // Start loading spinner
    //         // Clear previous data
    //         setDcCircuitData([]);
    //         setPointMachineData([]);
    //         setSignalData([]);
    //         setBatteriesData([]);
    //         setIPSData([]);
    //         setHassdacData([]);
    //         // Check if all required fields are selected
    //         if (!selectedStation || !selectedCategory || !selectedStartDate || !selectedEndDate) {
    //             toast.error('Please select all fields', { position: toast.POSITION.TOP_RIGHT });
    //             return;
    //         }
    //         // Create request object
    //         const request = {
    //             stationId: selectedStation,
    //             category: selectedCategory,
    //             startDate: selectedStartDate,
    //             endDate: selectedEndDate,
    //         };

    //         // Fetch report data
    //         const response = await getReportAPI(request);
    //         if (response) {
    //             // Map and set DC Circuit Data
    //             if (response.dcCircuit?.length > 0) {
    //                 const dcCircuitData = response.dcCircuit.map((t) => ({
    //                     id: t._id,
    //                     timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
    //                     trackNumber: t.track_number,
    //                     feedEndVoltage: renderStatus(t.severity_status[0].feedEndVoltage, t.feed_end_voltage),
    //                     relayEndVoltage: renderStatus(t.severity_status[0].relayEndVoltage, t.relay_end_voltage),
    //                     chargerCurrent: renderStatus(t.severity_status[0].chargerCurrent, t.charger_current),
    //                     tprStatus: renderBadge(t.tpr_status),
    //                     chargerPotentialFreeContact: renderBadge(t.charger_potential_free_contact),
    //                     relayEndCurrent: renderStatus(t.severity_status[0].relayEndCurrent, t.relay_end_current),
    //                     feedEndCurrent: renderStatus(t.severity_status[0].feedEndCurrent, t.feed_end_current),
    //                 }));
    //                 setDcCircuitData(dcCircuitData);
    //             }

    //             // Map and set Point Machine Data
    //             if (response.pointMachine?.length > 0) {
    //                 const pointMachineData = response.pointMachine.map((t) => ({
    //                     id: t._id,
    //                     timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
    //                     pointMachine: t.point_machine,
    //                     forwardOperatingCurrent: renderStatus(
    //                         t.severity_status[0].forwardOperatingCurrent,
    //                         t.forward_operating_current
    //                     ),
    //                     reverseOperatingCurrent: renderStatus(
    //                         t.severity_status[0].reverseOperatingCurrent,
    //                         t.reverse_operating_current
    //                     ),
    //                     forwardOperatingVoltage: renderStatus(
    //                         t.severity_status[0].forwardOperatingVoltage,
    //                         t.forward_operating_voltage
    //                     ),
    //                     reverseOperatingVoltage: renderStatus(
    //                         t.severity_status[0].reverseOperatingVoltage,
    //                         t.reverse_operating_voltage
    //                     ),
    //                     pointPositionVoltage: renderBadge(t.point_position_voltage),
    //                     vibration: renderStatus('NA', t.severity_status[0].vibration),
    //                     pointPositionRelay: renderBadge(t.point_position_relay),
    //                 }));
    //                 setPointMachineData(pointMachineData);
    //             }
    //             // Map and set Signal Data
    //             if (response.signal?.length > 0) {
    //                 const signalData = response.signal.map((t) => ({
    //                     id: t._id,
    //                     timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
    //                     signalNumber: t.signal_number,
    //                     redAcVoltage: renderStatus(t.severity_status[0].redAcVoltage, t.red_ac_voltage),
    //                     redAcCurrent: renderStatus(t.severity_status[0].redAcCurrent, t.red_ac_current),
    //                     greenAcVoltage: renderStatus(t.severity_status[0].greenAcVoltage, t.green_ac_voltage),
    //                     greenAcCurrent: renderStatus(t.severity_status[0].greenAcCurrent, t.green_ac_current),
    //                     yellowAcVoltage: renderStatus(t.severity_status[0].yellowAcVoltage, t.yellow_ac_voltage),
    //                     yellowAcCurrent: renderStatus(t.severity_status[0].yellowAcCurrent, t.yellow_ac_current),
    //                     otherAcVoltage: renderStatus(t.severity_status[0].otherAcVoltage, t.other_ac_voltage),
    //                     otherAcCurrent: renderStatus(t.severity_status[0].otherAcCurrent, t.other_ac_current),
    //                     status: renderBadge(t.health_status),
    //                 }));
    //                 setSignalData(signalData);
    //             }
    //             // Map and set Batteries Data
    //             if (response.batteries?.length > 0) {
    //                 const batteriesData = response.batteries.map((t) => ({
    //                     id: t._id,
    //                     timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
    //                     batteryCharger: t.battery_charger,
    //                     chargerInputVoltage: renderStatus(
    //                         t.severity_status[0].chargerInputVoltage,
    //                         t.charger_input_voltage
    //                     ),
    //                     chargerInputCurrent: renderStatus(
    //                         t.severity_status[0].chargerInputCurrent,
    //                         t.charger_input_current
    //                     ),
    //                     chargerOutputVoltage: renderStatus(
    //                         t.severity_status[0].chargerOutputVoltage,
    //                         t.charger_output_voltage
    //                     ),
    //                     chargerOutputCurrent: renderStatus(
    //                         t.severity_status[0].chargerOutputCurrent,
    //                         t.charger_output_current
    //                     ),
    //                     batteryOutputVoltage: renderStatus(
    //                         t.severity_status[0].batteryOutputVoltage,
    //                         t.battery_output_voltage
    //                     ),
    //                     batteryOutputCurrent: renderStatus(
    //                         t.severity_status[0].batteryOutputCurrent,
    //                         t.battery_output_current
    //                     ),
    //                 }));
    //                 setBatteriesData(batteriesData);
    //             }
    //             // Map and set IPS Data
    //             if (response.ips?.length > 0) {
    //                 const ipsData = response.ips.map((t) => ({
    //                     id: t._id,
    //                     timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
    //                     ips: t.ips,
    //                     inputVoltage: renderStatus(t.severity_status[0].inputVoltage, t.input_voltage),
    //                     inputCurrent: renderStatus(t.severity_status[0].inputCurrent, t.input_current),
    //                     frbcOutputVoltage: renderStatus(t.severity_status[0].FRBCOutputVoltage, t.frbc_output_voltage),
    //                     batteryOutputVoltage: renderStatus(
    //                         t.severity_status[0].batteryOutputVoltage,
    //                         t.battery_output_voltage
    //                     ),
    //                     batteryChargingCurrent: renderStatus(
    //                         t.severity_status[0].batteryChargingCurrent,
    //                         t.battery_charging_current
    //                     ),
    //                     dcConverterOutputCurrent: renderStatus(
    //                         t.severity_status[0].dcConverterOutputCurrent,
    //                         t.dc_converter_output_current
    //                     ),
    //                     dcConverterOutputVoltage: renderStatus(
    //                         t.severity_status[0].dcConverterOutputVoltage,
    //                         t.dc_converter_output_voltage
    //                     ),
    //                     inverterInputVoltage: renderStatus(
    //                         t.severity_status[0].inverterInputVoltage,
    //                         t.inverter_input_voltage
    //                     ),
    //                     inverterOutputVoltage: renderStatus(
    //                         t.severity_status[0].inverterOutputVoltage,
    //                         t.inverter_output_voltage
    //                     ),
    //                     inverterOutputCurrent: renderStatus(
    //                         t.severity_status[0].inverterOutputCurrent,
    //                         t.inverter_output_current
    //                     ),
    //                     healthOfIPSModulesThroughPFC: renderBadgeIPS(t.health_of_ips_modules_through_pfc),
    //                     availabilityOfStandbyPowerSupply: renderBadgeIPS(t.availability_of_stand_by_power_supply),
    //                 }));
    //                 setIPSData(ipsData);
    //             }

    //             if (response.hassdac?.length > 0) {
    //                 const hassdacData = response.hassdac.map((t) => ({
    //                     id: t._id,
    //                     timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
    //                     hassdac: t.hassdac,
    //                     inputVoltage: renderStatus(t.severity_status[0].inputVoltage, t.input_voltage),
    //                     vitalrelayVoltage: renderStatus(t.severity_status[0].vitalrelayVoltage, t.vital_relay_voltage),
    //                     inputCurrent: renderStatus(t.severity_status[0].inputCurrent, t.input_current),
    //                     vitalrelayCurrent: renderStatus(t.severity_status[0].vitalrelayCurrent, t.vital_relay_current),
    //                     resetVoltage: renderStatus(t.severity_status[0].resetVoltage, t.reset_voltage),
    //                 }));
    //                 setHassdacData(hassdacData);
    //             }

    //             const allData = [
    //                 ...dcCircuitData,
    //                 ...pointMachineData,
    //                 ...signalData,
    //                 ...batteriesData,
    //                 ...ipsData,
    //                 ...hassdacData,
    //             ].filter((item) => item && Object.keys(item).length > 0);

    //             setData(allData);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching report:', error);
    //         toast.error('Failed to fetch report', { position: toast.POSITION.TOP_RIGHT });
    //     } finally {
    //         Loading(false); // Stop loading spinner
    //     }
    // };
    const handleGetReport = async () => {
        try {
            Loading(true);
            setDcCircuitData([]);
            setPointMachineData([]);
            setSignalData([]);
            setBatteriesData([]);
            setIPSData([]);
            setHassdacData([]);
            setData([]);

            if (!selectedStation || !selectedCategory || !selectedStartDate || !selectedEndDate) {
                toast.error('Please select all fields', { position: toast.POSITION.TOP_RIGHT });
                return;
            }

            const request = {
                stationId: selectedStation,
                category: selectedCategory,
                startDate: selectedStartDate,
                endDate: selectedEndDate,
            };

            const response = await getReportAPI(request);

            if (response) {
                let dcCircuitData = [],
                    pointMachineData = [],
                    signalData = [],
                    batteriesData = [],
                    ipsData = [],
                    hassdacData = [];

                const allEmpty =
                    response.dcCircuit.length === 0 &&
                    response.pointMachine.length === 0 &&
                    response.signal.length === 0 &&
                    response.batteries.length === 0 &&
                    response.ips.length === 0 &&
                    response.hassdac.length === 0;

                if (allEmpty) {
                    toast.info('No data found for selected date range', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }

                if (response.dcCircuit?.length > 0) {
                    dcCircuitData = response.dcCircuit.map((t) => ({
                        id: t._id,
                        timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
                        trackNumber: t.track_number,
                        feedEndVoltage: renderStatus(t.severity_status[0].feedEndVoltage, t.feed_end_voltage),
                        relayEndVoltage: renderStatus(t.severity_status[0].relayEndVoltage, t.relay_end_voltage),
                        chargerCurrent: renderStatus(t.severity_status[0].chargerCurrent, t.charger_current),
                        tprStatus: renderBadge(t.tpr_status),
                        chargerPotentialFreeContact: renderBadge(t.charger_potential_free_contact),
                        relayEndCurrent: renderStatus(t.severity_status[0].relayEndCurrent, t.relay_end_current),
                        feedEndCurrent: renderStatus(t.severity_status[0].feedEndCurrent, t.feed_end_current),
                    }));
                }

                if (response.pointMachine?.length > 0) {
                    pointMachineData = response.pointMachine.map((t) => ({
                        id: t._id,
                        timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
                        pointMachine: t.point_machine,
                        forwardOperatingCurrent: renderStatus(
                            t.severity_status[0].forwardOperatingCurrent,
                            t.forward_operating_current
                        ),
                        reverseOperatingCurrent: renderStatus(
                            t.severity_status[0].reverseOperatingCurrent,
                            t.reverse_operating_current
                        ),
                        forwardOperatingVoltage: renderStatus(
                            t.severity_status[0].forwardOperatingVoltage,
                            t.forward_operating_voltage
                        ),
                        reverseOperatingVoltage: renderStatus(
                            t.severity_status[0].reverseOperatingVoltage,
                            t.reverse_operating_voltage
                        ),
                        pointPositionVoltage: renderBadge(t.point_position_voltage),
                        vibration: renderStatus('NA', t.severity_status[0].vibration),
                        pointPositionRelay: renderBadge(t.point_position_relay),
                    }));
                }

                if (response.signal?.length > 0) {
                    signalData = response.signal.map((t) => ({
                        id: t._id,
                        timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
                        signalNumber: t.signal_number,
                        redAcVoltage: renderStatus(t.severity_status[0].redAcVoltage, t.red_ac_voltage),
                        redAcCurrent: renderStatus(t.severity_status[0].redAcCurrent, t.red_ac_current),
                        greenAcVoltage: renderStatus(t.severity_status[0].greenAcVoltage, t.green_ac_voltage),
                        greenAcCurrent: renderStatus(t.severity_status[0].greenAcCurrent, t.green_ac_current),
                        yellowAcVoltage: renderStatus(t.severity_status[0].yellowAcVoltage, t.yellow_ac_voltage),
                        yellowAcCurrent: renderStatus(t.severity_status[0].yellowAcCurrent, t.yellow_ac_current),
                        otherAcVoltage: renderStatus(t.severity_status[0].otherAcVoltage, t.other_ac_voltage),
                        otherAcCurrent: renderStatus(t.severity_status[0].otherAcCurrent, t.other_ac_current),
                        status: renderBadge(t.health_status),
                    }));
                }

                if (response.batteries?.length > 0) {
                    batteriesData = response.batteries.map((t) => ({
                        id: t._id,
                        timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
                        batteryCharger: t.battery_charger,
                        chargerInputVoltage: renderStatus(
                            t.severity_status[0].chargerInputVoltage,
                            t.charger_input_voltage
                        ),
                        chargerInputCurrent: renderStatus(
                            t.severity_status[0].chargerInputCurrent,
                            t.charger_input_current
                        ),
                        chargerOutputVoltage: renderStatus(
                            t.severity_status[0].chargerOutputVoltage,
                            t.charger_output_voltage
                        ),
                        chargerOutputCurrent: renderStatus(
                            t.severity_status[0].chargerOutputCurrent,
                            t.charger_output_current
                        ),
                        batteryOutputVoltage: renderStatus(
                            t.severity_status[0].batteryOutputVoltage,
                            t.battery_output_voltage
                        ),
                        batteryOutputCurrent: renderStatus(
                            t.severity_status[0].batteryOutputCurrent,
                            t.battery_output_current
                        ),
                    }));
                }

                if (response.ips?.length > 0) {
                    ipsData = response.ips.map((t) => ({
                        id: t._id,
                        timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
                        ips: t.ips,
                        inputVoltage: renderStatus(t.severity_status[0].inputVoltage, t.input_voltage),
                        inputCurrent: renderStatus(t.severity_status[0].inputCurrent, t.input_current),
                        frbcOutputVoltage: renderStatus(t.severity_status[0].FRBCOutputVoltage, t.frbc_output_voltage),
                        batteryOutputVoltage: renderStatus(
                            t.severity_status[0].batteryOutputVoltage,
                            t.battery_output_voltage
                        ),
                        batteryChargingCurrent: renderStatus(
                            t.severity_status[0].batteryChargingCurrent,
                            t.battery_charging_current
                        ),
                        dcConverterOutputCurrent: renderStatus(
                            t.severity_status[0].dcConverterOutputCurrent,
                            t.dc_converter_output_current
                        ),
                        dcConverterOutputVoltage: renderStatus(
                            t.severity_status[0].dcConverterOutputVoltage,
                            t.dc_converter_output_voltage
                        ),
                        inverterInputVoltage: renderStatus(
                            t.severity_status[0].inverterInputVoltage,
                            t.inverter_input_voltage
                        ),
                        inverterOutputVoltage: renderStatus(
                            t.severity_status[0].inverterOutputVoltage,
                            t.inverter_output_voltage
                        ),
                        inverterOutputCurrent: renderStatus(
                            t.severity_status[0].inverterOutputCurrent,
                            t.inverter_output_current
                        ),
                        healthOfIPSModulesThroughPFC: renderBadgeIPS(t.health_of_ips_modules_through_pfc),
                        availabilityOfStandbyPowerSupply: renderBadgeIPS(t.availability_of_stand_by_power_supply),
                    }));
                }

                if (response.hassdac?.length > 0) {
                    hassdacData = response.hassdac.map((t) => ({
                        id: t._id,
                        timeStamp: moment(t.updatedAt).format('Do MMM YYYY h:mm a'),
                        hassdac: t.hassdac,
                        inputVoltage: renderStatus(t.severity_status[0].inputVoltage, t.input_voltage),
                        vitalrelayVoltage: renderStatus(t.severity_status[0].vitalrelayVoltage, t.vital_relay_voltage),
                        inputCurrent: renderStatus(t.severity_status[0].inputCurrent, t.input_current),
                        vitalrelayCurrent: renderStatus(t.severity_status[0].vitalrelayCurrent, t.vital_relay_current),
                        resetVoltage: renderStatus(t.severity_status[0].resetVoltage, t.reset_voltage),
                    }));
                }

                // Now set all at once
                setDcCircuitData(dcCircuitData);
                setPointMachineData(pointMachineData);
                setSignalData(signalData);
                setBatteriesData(batteriesData);
                setIPSData(ipsData);
                setHassdacData(hassdacData);

                const allData = [
                    ...dcCircuitData,
                    ...pointMachineData,
                    ...signalData,
                    ...batteriesData,
                    ...ipsData,
                    ...hassdacData,
                ];
                setData(allData);
            }
        } catch (error) {
            console.error('Error fetching report:', error);
            toast.error('Failed to fetch report', { position: toast.POSITION.TOP_RIGHT });
        } finally {
            Loading(false);
        }
    };

    const inputRef = useRef(null);
    const printDocument = async () => {
        Loading();
        const options = {
            backgroundColor: '#f1f3fa',
            useCORS: true,
            allowTaint: false,
            logging: true,
            scale: 1,
        };

        try {
            const canvas = await html2canvas(inputRef.current, options);
            const imgData = canvas.toDataURL('image/png', 0.8);

            if (!imgData || imgData === 'data:,') {
                throw new Error('Invalid or empty image data');
            }

            const pdf = new jsPDF({
                orientation: canvas.width >= canvas.height ? 'l' : 'p',
                unit: 'px',
                compress: true,
            });

            const pageHeight = pdf.internal.pageSize.height;
            const imgHeight = (canvas.height * pdf.internal.pageSize.width) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, pdf.internal.pageSize.width, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, pdf.internal.pageSize.width, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save(`RDPMS Update Report - ${moment(new Date()).format('DD-MMM-YYYY')}.pdf`);
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error('Failed to generate PDF', { position: toast.POSITION.TOP_RIGHT });
        } finally {
            Loading(false);
        }
    };

    const exportToExcel = () => {
        try {
            const workbook = XLSX.utils.book_new();

            const getHeadersFromColumns = (columns) =>
                columns.map((col) => ({
                    header: col.Header,
                    key: col.accessor,
                }));

            const addSheet = (data, name, columns) => {
                if (!data || data.length === 0) return;

                const headers = getHeadersFromColumns(columns);
                if (!headers || headers.length === 0) return;

                const normalizedData = data.map((item) => {
                    const row = {};
                    headers.forEach(({ header, key }) => {
                        let value = item[key];

                        // Convert React elements or nested objects to plain text
                        if (typeof value === 'object' && value !== null) {
                            if (React.isValidElement(value)) {
                                value = value.props?.children || '';
                            } else {
                                value = JSON.stringify(value);
                            }
                        }

                        row[header] = value ?? '';
                    });
                    return row;
                });

                const ws = XLSX.utils.json_to_sheet(normalizedData);
                XLSX.utils.book_append_sheet(workbook, ws, name);
            };

            if (selectedCategory === 'all') {
                addSheet(dcCircuitData, 'DC Circuit', dcCircuitColumns(t));
                addSheet(pointMachineData, 'Point Machine', pointMachineColumns(t));
                addSheet(signalData, 'Signal', SignalColumns(t));
                addSheet(batteriesData, 'Batteries', batteriesColumns(t));
                addSheet(ipsData, 'IPS', IPSColumns(t));
                addSheet(hassdacData, 'HASSDAC', hassdacColumns(t));
            } else {
                switch (selectedCategory) {
                    case 'dcCircuit':
                        addSheet(dcCircuitData, 'DC Circuit', dcCircuitColumns(t));
                        break;
                    case 'pointMachine':
                        addSheet(pointMachineData, 'Point Machine', pointMachineColumns(t));
                        break;
                    case 'signal':
                        addSheet(signalData, 'Signal', SignalColumns(t));
                        break;
                    case 'batteries':
                        addSheet(batteriesData, 'Batteries', batteriesColumns(t));
                        break;
                    case 'ips':
                        addSheet(ipsData, 'IPS', IPSColumns(t));
                        break;
                    case 'hassdac':
                        addSheet(hassdacData, 'HASSDAC', hassdacColumns(t));
                        break;
                    default:
                        toast.warning('No valid category selected', { position: toast.POSITION.TOP_RIGHT });
                        return;
                }
            }

            // Verify at least one sheet exists
            if (workbook.SheetNames.length === 0) {
                toast.warning('No data available to export', { position: toast.POSITION.TOP_RIGHT });
                return;
            }

            // File name
            const fileName = `RDPMS ${selectedCategory === 'all' ? 'All Devices' : selectedCategory} Report - ${moment(
                new Date()
            ).format('DD-MMM-YYYY')}.xlsx`;

            XLSX.writeFile(workbook, fileName);
            setShowExportModal(false);
        } catch (error) {
            console.error('❌ Error generating Excel file:', error);
            toast.error('Failed to generate Excel', { position: toast.POSITION.TOP_RIGHT });
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="" style={{ width: '100%' }}>
                <div className="container-fluid px-2">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* REPORT ALERT Title */}
                        <div className="col-12 col-md-auto">
                            <h6 className="point-title fw-bold mb-0">REPORT ALERT</h6>
                        </div>

                        {/* Export and Update Buttons */}
                        <div className="col-12 col-md-auto ms-md-auto">
                            <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2">
                                {/* Export Button */}
                                <button
                                    className="export d-flex align-items-center justify-content-center flex-grow-1"
                                    type="button"
                                    onClick={() => setShowExportModal(true)}>
                                    Export <i className="fas fa-file-export ms-1"></i>
                                </button>

                                {/* Update Button */}
                                <button
                                    className="update d-flex align-items-center justify-content-center flex-grow-1"
                                    id="update">
                                    Update <i className="fas fa-sync-alt ms-1"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-4 p-3"
                    style={{
                        width: '100%',
                        boxShadow: ' 0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                    }}>
                    <div className="container form-container justify-content-center">
                        <form>
                            <div className="row d-flex flex-center">
                                {/* Station Dropdown */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="stationSelect">Station</label>
                                    <FormInput
                                        name="select"
                                        type="select"
                                        key="select"
                                        className="form-select"
                                        id="stationSelect"
                                        onChange={(e) => setSelectedStation(e.target.value)}>
                                        <option value="">Select station</option>
                                        {station &&
                                            station.map((item, index) => {
                                                return (
                                                    <option key={index} value={item._id}>
                                                        {item.name}
                                                    </option>
                                                );
                                            })}
                                    </FormInput>
                                </div>

                                {/* Category Dropdown */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="categorySelect">Category</label>
                                    <FormInput
                                        className="form-select"
                                        name="select"
                                        type="select"
                                        id="categorySelect"
                                        key="select"
                                        onChange={(e) => setSelectedCategory(e.target.value)}>
                                        <option value="">Select Category</option>
                                        <option value="all">ALL</option>
                                        <option value="dcCircuit">DC CIRCUIT</option>
                                        <option value="pointMachine">POINT MACHINE</option>
                                        <option value="signals">SIGNALS</option>
                                        <option value="batteries">BATTERIES</option>
                                        <option value="ips">IPS</option>
                                        <option value="hassdac">HASSDAC</option>
                                        {/* <option value="axialCounters">AXIAL COUNTERS</option>
                                    <option value="dataLogger">DATA LOGGER</option>
                                    <option value="electronicsInterlocking">ELECTRONIC INTERLOCKING</option> */}
                                    </FormInput>
                                </div>

                                {/* Start Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                    {selectedStartDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedStartDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                {/* End Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>
                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>
                                    {selectedEndDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedEndDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn "
                                        onClick={() => handleGetReport()}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div ref={inputRef}>
                    {dcCircuitData.length > 0 ? (
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header as="h4">
                                        {t('DC Circuit')}
                                        <Row>
                                            <Col
                                                style={{
                                                    fontSize: '16px',
                                                    marginTop: '15px',
                                                }}>
                                                {`${t('Start Date')} : ${moment(selectedStartDate).format(
                                                    'Do MMM YYYY'
                                                )} ${t('To')} ${t('End Date')} : ${moment(selectedEndDate).format(
                                                    'Do MMM YYYY'
                                                )}`}
                                            </Col>
                                            <Col>
                                                <div className="text-sm-end">
                                                    <img
                                                        src={reportImg}
                                                        alt="hamingbird"
                                                        style={{
                                                            width: '25%',
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Table
                                            columns={dcCircuitColumns(t)}
                                            data={dcCircuitData}
                                            isSortable={true}
                                            isSearchable={true}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        ''
                    )}
                    {hassdacData.length > 0 ? (
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h4">
                                        {t('Hassdac')}
                                        <Row>
                                            <Col
                                                style={{
                                                    fontSize: '16px',
                                                    marginTop: '15px',
                                                }}>
                                                {`${t('Start Date')} : ${moment(selectedStartDate).format(
                                                    'Do MMM YYYY'
                                                )} ${t('To')} ${t('End Date')} : ${moment(selectedEndDate).format(
                                                    'Do MMM YYYY'
                                                )}`}
                                            </Col>
                                            <Col>
                                                <div className="text-sm-end">
                                                    <img
                                                        src={reportImg}
                                                        alt="hamingbird"
                                                        style={{
                                                            width: '25%',
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Table
                                            columns={hassdacColumns(t)}
                                            data={hassdacData}
                                            isSortable={true}
                                            isSearchable={true}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        ''
                    )}

                    {pointMachineData.length > 0 ? (
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h4">
                                        {t('Point Machine')}
                                        <Row>
                                            <Col
                                                style={{
                                                    fontSize: '16px',
                                                    marginTop: '15px',
                                                }}>
                                                {`${t('Start Date')} : ${moment(selectedStartDate).format(
                                                    'Do MMM YYYY'
                                                )} ${t('To')} ${t('End Date')} : ${moment(selectedEndDate).format(
                                                    'Do MMM YYYY'
                                                )}`}
                                            </Col>
                                            <Col>
                                                <div className="text-sm-end">
                                                    <img
                                                        src={reportImg}
                                                        alt="hamingbird"
                                                        style={{
                                                            width: '25%',
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Table
                                            columns={pointMachineColumns(t)}
                                            data={pointMachineData}
                                            isSortable={true}
                                            isSearchable={true}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        ''
                    )}

                    {signalData.length > 0 ? (
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h4">
                                        {t('Signal')}
                                        <Row>
                                            <Col
                                                style={{
                                                    fontSize: '16px',
                                                    marginTop: '15px',
                                                }}>
                                                {`${t('Start Date')} : ${moment(selectedStartDate).format(
                                                    'Do MMM YYYY'
                                                )} ${t('To')} ${t('End Date')} : ${moment(selectedEndDate).format(
                                                    'Do MMM YYYY'
                                                )}`}
                                            </Col>
                                            <Col>
                                                <div className="text-sm-end">
                                                    <img
                                                        src={reportImg}
                                                        alt="hamingbird"
                                                        style={{
                                                            width: '25%',
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Table
                                            columns={SignalColumns(t)}
                                            data={signalData}
                                            isSortable={true}
                                            isSearchable={true}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        ''
                    )}

                    {batteriesData.length > 0 ? (
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h4">
                                        {t('Batteries')}
                                        <Row>
                                            <Col
                                                style={{
                                                    fontSize: '16px',
                                                    marginTop: '15px',
                                                }}>
                                                {`${t('Start Date')} : ${moment(selectedStartDate).format(
                                                    'Do MMM YYYY'
                                                )} ${t('To')} ${t('End Date')} : ${moment(selectedEndDate).format(
                                                    'Do MMM YYYY'
                                                )}`}
                                            </Col>
                                            <Col>
                                                <div className="text-sm-end">
                                                    <img
                                                        src={reportImg}
                                                        alt="hamingbird"
                                                        style={{
                                                            width: '25%',
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Table
                                            columns={batteriesColumns(t)}
                                            data={batteriesData}
                                            isSortable={true}
                                            isSearchable={true}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        ''
                    )}

                    {ipsData.length > 0 ? (
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h4">
                                        {t('IPS')}
                                        <Row>
                                            <Col
                                                style={{
                                                    fontSize: '16px',
                                                    marginTop: '15px',
                                                }}>
                                                {`${t('Start Date')} : ${moment(selectedStartDate).format(
                                                    'Do MMM YYYY'
                                                )} ${t('To')} ${t('End Date')} : ${moment(selectedEndDate).format(
                                                    'Do MMM YYYY'
                                                )}`}
                                            </Col>
                                            <Col>
                                                <div className="text-sm-end">
                                                    <img
                                                        src={reportImg}
                                                        alt="hamingbird"
                                                        style={{
                                                            width: '25%',
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body>
                                        <Table
                                            columns={IPSColumns(t)}
                                            data={ipsData}
                                            isSortable={true}
                                            isSearchable={true}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        ''
                    )}
                </div>
                <Modal show={showExportModal} onHide={() => setShowExportModal(false)} centered>
                    <Modal.Header closeButton className="bg-primary text-white" closeVariant="white">
                        <Modal.Title>Export Report</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p>Select a format to export your report:</p>
                        <div className="d-flex justify-content-center gap-3 mt-3">
                            <Button
                                variant="success"
                                onClick={() => {
                                    setShowExportModal(false);
                                    printDocument();
                                }}>
                                Export as PDF <i className="fas fa-file-pdf ms-1"></i>
                            </Button>
                            <Button variant="info" onClick={exportToExcel}>
                                Export as Excel <i className="fas fa-file-excel ms-1"></i>
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default ReportsAlert;
